'use client'

import React from 'react'
import katex from 'katex'
import 'katex/dist/katex.min.css'
import { decodeTextEntities } from './plain-text'

// URL-carried text is data, never Markdown or HTML. Only explicit maths
// delimiters are rendered, with KaTeX's trusted commands disabled.
export function PlainTextMath({ text }: { text: string }) {
  // Axi escapes < and > as entities; decode them (the result is still
  // rendered as text). Legacy tutor responses use br separators. Convert
  // only this exact tag, never parse HTML or attributes. All other markup
  // remains inert text.
  const pieces = decodeTextEntities(text)
    .replace(/<br\s*\/?>/gi, '\n')
    .split(/(\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]|\$\$[\s\S]*?\$\$|(?<![\\$])\$(?!\$)(?:[^\s$\\]|\\[^\n])(?:[^$\n]*?[^\s$\\])?(?<!\\)\$(?!\$))/g)
  return (
    <div className="whitespace-pre-wrap break-words">
      {pieces.map((piece, index) => {
        const display = piece.startsWith('\\[') || piece.startsWith('$$')
        const inlineDollar = piece.startsWith('$') && !display
        const math = display || piece.startsWith('\\(') || inlineDollar
        if (!math) return <React.Fragment key={index}>{piece}</React.Fragment>
        const expression = piece.slice(inlineDollar ? 1 : 2, inlineDollar ? -1 : -2)
        try {
          const html = katex.renderToString(expression, {
            displayMode: display,
            throwOnError: true,
            trust: false,
            strict: 'error',
            maxExpand: 100,
            maxSize: 10,
          })
          return (
            <span
              key={index}
              className="max-w-full overflow-x-auto"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          )
        } catch {
          return <React.Fragment key={index}>{piece}</React.Fragment>
        }
      })}
    </div>
  )
}
